// 商品ギャラリープログレスバー（SP）
window.initProductMediaProgress = function (retryCount = 0) {
  document
    .querySelectorAll('.product_template media-gallery')
    .forEach((gallery) => {
      const slideshow = gallery.querySelector('slideshow-component');
      const bar = gallery.querySelector('.media-progress__bar');

      // まだDOM/Shopify側JSの準備ができていない場合は少し待って再実行
      if (!slideshow || !bar || !slideshow.slides?.length) {
        if (retryCount < 10) {
          setTimeout(() => {
            window.initProductMediaProgress(retryCount + 1);
          }, 100);
        }
        return;
      }

      // ここで初めて初期化済みにする
      if (gallery.dataset.progressInitialized === 'true') return;
      gallery.dataset.progressInitialized = 'true';

      const total = slideshow.slides.length;

      bar.style.width = `${100 / total}%`;

      const updateProgress = (index = 0) => {
        bar.style.transform = `translateX(${index * 100}%)`;
      };

      updateProgress(0);

      slideshow.addEventListener('slideshow:select', (event) => {
        const index = event.detail?.index || 0;
        updateProgress(index);
      });
    });
};

// 最近見た商品の保存
window.saveCurrentProductToRecentlyViewed = function () {
  const jsonEl = document.querySelector('#current-product-json');
  if (!jsonEl) return;

  let currentProduct;

  try {
    currentProduct = JSON.parse(jsonEl.textContent);
  } catch (e) {
    console.warn('current product json parse error', e);
    return;
  }

  let products = [];

  try {
    products = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
  } catch (e) {
    products = [];
  }

  products = products.filter((p) => p.id !== currentProduct.id);
  products.unshift(currentProduct);
  products = products.slice(0, 8);

  localStorage.setItem('recentlyViewedProducts', JSON.stringify(products));
};

// 初期化まとめ
function initProductPageFeatures() {
  window.initCartGlowButtons?.();
  window.initProductMediaProgress?.();
  window.saveCurrentProductToRecentlyViewed?.();
  window.renderRecentlyViewedProducts?.();
}

// 初回実行
document.addEventListener('DOMContentLoaded', () => {
  initProductPageFeatures();
});

// スワッチ遷移時 処理
document.addEventListener('click', async (e) => {
  const link = e.target.closest('.product-card-color-swatches__item[href]');
  if (!link) return;

  e.preventDefault();

  const href = link.getAttribute('href');
  if (!href) return;

  const nextUrl = new URL(href, window.location.origin);

  const res = await fetch(nextUrl.pathname);
  const html = await res.text();

  const doc = new DOMParser().parseFromString(html, 'text/html');

  const newGrid = doc.querySelector('.product-information__grid');
  const currentGrid = document.querySelector('.product-information__grid');

  if (!newGrid || !currentGrid) {
    return;
  }

  // 詳細全体
  currentGrid.innerHTML = newGrid.innerHTML;

  // 動的要素
  requestAnimationFrame(() => {
    initProductPageFeatures();
  });

  window.history.pushState({}, '', nextUrl.pathname);
});

// ヘッダー見た目（更新なし）
document.addEventListener('DOMContentLoaded', () => {
  const headerSection = document.querySelector(
    '#header-group > .header-section'
  );
  const drawer = document.querySelector('.menu-drawer-container');

  if (!headerSection || !drawer) return;

  const update = () => {
    const isOpen = drawer.hasAttribute('open');

    headerSection.classList.toggle('is-menu-open-or-closing', isOpen);
  };

  // 初期
  update();

  // open/close監視
  const observer = new MutationObserver(update);

  observer.observe(drawer, {
    attributes: true,
    attributeFilter: ['open'],
  });
});
